import { buildContext } from '@coveo/headless';
import { headlessEngine, headlessEngineModal } from '../engine';
import { coveoContextModal } from '../controllers/controller';

export function CoveoContext() {
  if (headlessEngine) {
    const context = buildContext(headlessEngine);

    return context;
  }
  return null;
}

export function CoveoContextModal() {
  if (headlessEngineModal) {
    const context = buildContext(headlessEngineModal);
    context.set(coveoContextModal);
  }
  return null;
}
